export const firstLetterToUppercase = (string) => {
  if (typeof string === 'string') {
    const firstLetterToUppercase = string.charAt(0).toUpperCase();
    const stringWithoutFirstLetter = string.slice(1);
    return firstLetterToUppercase + stringWithoutFirstLetter;
  }
  return '';
};

export const firstLetterToLowercase = (string) => {
  if (typeof string === 'string') {
    const firstLetterToUppercase = string.charAt(0).toLowerCase();
    const stringWithoutFirstLetter = string.slice(1);
    return firstLetterToUppercase + stringWithoutFirstLetter;
  }
  return '';
};

export const getInitials = (name) => {
  let trimName = (name || '').trimEnd();
  const arr = trimName.split(' ');
  return arr.length ? arr[0][0] + arr[arr.length - 1][0] : arr[0][0];
};

export const formatUSNumber = (number) => {
  if (!number) {
    return 'Unknown Number';
  }
  let cleaned = ('' + number).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return ['(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return 'International Call';
};

export const slugify = (str = '') => {
  return str.replace(/\s+/g, '-').toLowerCase();
};
